<template>
  <TsTypography
    v-if="!isMobile"
    as="div"
    variant="sm"
    size="sm"
    append-class="flex text-primary items-center lg:justify-end space-x-2 mb-0"
  >
    <TsVatToggle />
  </TsTypography>
</template>
<script setup lang="ts">
const TsVatToggle = defineAsyncComponent(() => import('~/components/organisms/TsVatToggle.vue'));

const { isMobile } = useDevice();
</script>
